import type { CatalogEdition } from '@/lib/whats-new/edition-types';

export type NewsEditionsStatus = 'loading' | 'ready' | 'error';

export interface AutoOpenInput {
  /** Current `location.pathname`. */
  pathname: string;
  tenantSlug: string;
  isAppUnderConstruction: boolean;
  /** The store's API answered `402 billing_locked`. */
  billingLocked: boolean;
  /** Dialogs/sheets registered through `useRegisterModal`. */
  openModalsCount: number;
  /** Where an open dialog that does not register itself is looked up. */
  root: Pick<ParentNode, 'querySelector'>;
  status: NewsEditionsStatus;
  /** `resolveLatest(catalog)`; `seenAt` is the backend's view. */
  latest: CatalogEdition | null;
  /** Editions marked as seen in this tab, whatever the POST answered. */
  seenInSession: ReadonlySet<string>;
}

const OPEN_DIALOG_SELECTOR = '[role="dialog"][data-state="open"]';

/**
 * Whether the latest edition opens on its own (NEWS-15/16/19/20/21): only on
 * the Início, with the catalog loaded, the latest edition unseen (backend and
 * this tab), the app not under construction, the store not billing-locked
 * and no other dialog or sheet open.
 */
export function shouldAutoOpen(input: AutoOpenInput): boolean {
  const { latest } = input;
  if (latest === null) return false;
  if (input.status !== 'ready') return false;
  if (latest.seenAt !== null || input.seenInSession.has(latest.id)) {
    return false;
  }
  const homePath = `/${input.tenantSlug}/dashboard`;
  if (input.pathname !== homePath && input.pathname !== `${homePath}/`) {
    return false;
  }
  if (input.isAppUnderConstruction || input.billingLocked) return false;
  if (input.openModalsCount > 0) return false;
  return input.root.querySelector(OPEN_DIALOG_SELECTOR) === null;
}
